module.exports = __webpack_public_path__ + "img/bg-icon3.cc4a39d4.png";